<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 09:18:20
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-11 20:31:19
 * @FilePath: \vue-privilege-routing\src\pages\business\shop-mall\index.vue
-->
<template>
  <div>
     <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
      return {}
  }
}
</script>
